<template>
  <div class="indexContent">
    <div class="indexHeader">
      <div class="leftLogoTitle">
        <div class="logoBox">
<!--          <img src="../../../assets/smallLogo.png">-->
        </div>
        <div class="logoTxt">
<!--          <img src="../../../assets/logoTxt1.png">-->
        </div>
      </div>
      <div class="rightMenu">
        <div  class="menuBox"  v-for="(item,index) in menuList"  :key="index"  @click="checkMenu(item)">
          <div class="boxMain" :class="currentActive === item.id ? 'activeMenu' : ''">
            <div class="topName">{{ item.chineseName }}</div>
            <div class="bottomEnglishName">{{ item.engLishName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="indexMain">
      <div class="indexSidebar">
        <div class="userInfo">
          <div class="userMsg" @click="gotoUserInfo">
            <div class="leftImg">
              <div class="imgBoxClass">
                <img :src="userInfoMsg.avatar" style="width: 100%">
              </div>
<!--              <img src="../../assets/smallLogo.png" alt="">-->
            </div>
            <div class="rightInfo">
              <div class="userName">
                {{ userInfoMsg.nickName }}
              </div>
              <div class="zhicheng">
                {{ userInfoMsg.role }}
              </div>
              <div class="dengluTime">
                上次登陆：{{ userInfoMsg.lastLoginTime }}
              </div>
            </div>
          </div>
          <div class="vipTips">
            <el-divider><i class="el-icon-mobile-phone"></i>
              会员将在 {{ userInfoMsg.vipExpireTime }}到期
            </el-divider>
          </div>
        </div>
        <div class="paiming">
          <div class="navList" v-for="(item,index) in navBarList" :key="index">
            <div class="navIcon">
              <img :src="item.icon" alt="">
            </div>
            <div class="navNum">
              {{item.num}}
            </div>
            <div class="navTxt">
              {{ item.nameTxt }}
            </div>
          </div>
        </div>
        <div class="kechengBox">
          <div class="myKecheng">
            <div class="titleBox">
              <div class="leftIcon">
                <img src="../../assets/icon7.png" style="width: 100%">
              </div>
              <div class="rightTxtx">
                <div class="zhuTitle">
                  我的课程
                </div>
                <div class="ciTitle">
                  个性化订阅内容
                </div>
              </div>
            </div>
            <div class="titleList">
              <div class="listOne" v-for="(item,index) in myCourse" :key="index" @click="gotoPathPages(item)">
                <div class="leftIcon">
                  <img src="../../assets/icon6.png" style="width: 100%">
                </div>
                <div class="rightTxtx">
                  {{ item.courseName }}
                </div>
              </div>
            </div>
          </div>
          <div class="YesKecheng">
            <div class="titleBox">
              <div class="leftIcon">
                <img src="../../assets/icon8.png" style="width: 100%">
              </div>
              <div class="rightTxtx">
                <div class="zhuTitle">
                  已完成的课程
                </div>
                <div class="ciTitle">
                  可抗遗忘训练
                </div>
              </div>
            </div>
            <div class="titleList">
              <div class="listOne" v-for="(item,index) in CompletedCourses" :key="index" @click="gotoPathPages(item)">
                <div class="leftIcon">
                  <img src="../../assets/icon6.png" style="width: 100%">
                </div>
                <div class="rightTxtx">
                  {{ item.courseName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="indexPageContent">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  data() {
    return{
      userInfoMsg:{
        avatar: require("@/assets/smallLogo.png"),
      },
      menuList:[
        {
          id:1,
          chineseName:'首页',
          engLishName:'Home',
          routerPath:'/index/home'
        },
        {
          id:2,
          chineseName:'词汇练习',
          engLishName:'Word Study',
          routerPath:'/index/VocabularyPractice/index'
        },
        {
          id:3,
          chineseName:'单词表',
          engLishName:'Word Lists',
          routerPath:'/index/wordList'
        },
        {
          id:4,
          chineseName:'学习报告',
          engLishName:'Studying Reports',
          routerPath:'/index/studyReport'
        },
        {
          id:5,
          chineseName:'退出登录',
          engLishName:'Log Out'
        },
      ],
      currentActive:1,
      navBarList:[
        {
          icon:require('../../../assets/icon2.png'),
          num:'0周',
          nameTxt:'累计学习'
        },
        {
          icon:require('../../../assets/icon3.png'),
          num:'0',
          nameTxt:'今日掌握'
        },
        {
          icon:require('../../../assets/icon4.png'),
          num:'0',
          nameTxt:'单词总量'
        },
        {
          icon:require('../../../assets/icon5.png'),
          num:'0',
          nameTxt:'满分次数'
        }
      ],
      // 我的课程
      myCourse:[],
      // 已完成课程
      CompletedCourses:[]
    }
  },
  mounted() {
    let routePath = this.$route.path;
    this.menuList.forEach(item => {
      if(item.routerPath === routePath){
        this.currentActive = item.id;
      }
    })

    // 如果已登录（有 token），初始化背景音乐
    const token = localStorage.getItem('token');
    if (token && this.$musicManager) {
      this.$musicManager.init();
    }

     //获取用户信息
     this.getUserInfo();
    //获取用户左侧信息
    this.getLeftMenuMsg();
  },
  methods:{
    getUserInfo(){
      this.$axios.get('/api/profile/info').then(res => {
        console.log(res.data);
        res.data.lastLoginTime = moment(res.data.lastLoginTime).format('YYYY-MM-DD HH:mm');
        res.data.vipExpireTime = moment(res.data.vipExpireTime).format('YYYY-MM-DD HH:mm');
        
        // 先读取 localStorage 中已保存的音乐状态，避免覆盖用户手动设置的状态
        let savedMusicState = null;
        try {
          const savedUserInfo = localStorage.getItem('userInfoMsg');
          if (savedUserInfo) {
            const parsed = JSON.parse(savedUserInfo);
            if (parsed.alphaMusic !== undefined && parsed.alphaMusic !== null) {
              savedMusicState = parsed.alphaMusic;
            }
          }
        } catch (e) {
          console.error('读取保存的音乐状态失败:', e);
        }
        
        // 如果服务器返回的数据中没有 alphaMusic 字段或为 null
        if (res.data.alphaMusic === undefined || res.data.alphaMusic === null) {
          // 如果 localStorage 中有保存的状态，使用保存的状态；否则默认关闭（0）
          res.data.alphaMusic = savedMusicState !== null ? savedMusicState : 0;
        }
        // 如果服务器返回了 alphaMusic，但 localStorage 中有用户手动设置的状态，优先使用用户设置的状态
        else if (savedMusicState !== null && savedMusicState !== res.data.alphaMusic) {
          // 保留用户手动设置的状态
          res.data.alphaMusic = savedMusicState;
        }
        
        this.userInfoMsg = res.data;
        this.navBarList[0].num = res.data.totalStudyDays;
        this.navBarList[1].num = res.data.todayMasteredWords;
        this.navBarList[2].num = res.data.totalMasteredWords;
        this.navBarList[3].num = res.data.perfectScoreTimes;
        localStorage.setItem('userInfoMsg', JSON.stringify(res.data));
        
        // 确保音乐管理器状态与 localStorage 同步
        if (this.$musicManager) {
          this.$musicManager.loadState();
          if (this.$musicManager.getState()) {
            this.$musicManager.play();
          }
        }
      })
    },
    getLeftMenuMsg(){
      this.$axios.get('/api/v1/courses/my-courses').then(res => {
        console.log(res.data);
        this.myCourse = res.data.registered
        this.CompletedCourses = res.data.completed
      })
    },
    checkMenu(item) {

      if (item.chineseName === '退出登录') {
        // 处理退出登录逻辑
        // 关闭背景音乐（必须在路由跳转前执行）
        if (this.$musicManager) {
          this.$musicManager.logout();
        }
        // 移除 token
        localStorage.removeItem('token');
        // 跳转到登录页
        this.$router.push('/').catch(() => {});
        return;
      }

      // 避免重复点击当前路由
      if (this.$route.path !== item.routerPath) {
        this.currentActive = item.id;
        localStorage.setItem('currentActive', item.id);
        this.$router.push(item.routerPath);
      }
    },
    gotoUserInfo(){
      this.$router.push({
        path:'/index/userInfo'
      })
    },
    // 点击我的课程跳转
    gotoPathPages(item){
      console.log(item)
      this.currentActive = 2
      console.log(this.$route.path)

      // 判断当前路由是否为指定页面，如果是指定页面就判断当前参数是否一致，如果一致就不跳转，否则就跳转
      if(this.$route.path === '/index/VocabularyPractice/unitStudy' && this.$route.query.courseId === item.courseId){
        console.log('不跳转')
      }else{
        this.$router.push({
          path:'/index/VocabularyPractice/unitStudy',
          query:{
            courseId:item.courseId,
            courseName:item.courseName,
          }
        })
      }




    }
  },


}
</script>
<style scoped lang="scss">
.indexContent{
  width: 100%;
  height: 100vh;
  background-color:#01AF9E;


  .indexHeader{
      width: 100%;
      height: 80px;
      display: flex;

      .leftLogoTitle{
        width: 400px;
        height: 100%;
        display: flex;
        padding-left: 20px;

        .logoBox{
          width: 60px;
          height: 100%;
          display: flex;
          align-items: center;
          background-image: url("../../../assets/smallLogo.png");
          background-repeat: no-repeat;
          //background-size: contain;
          background-position: center;
        }

        .logoTxt{
          width: calc(100% - 50px);
          height: 100%;
          display: flex;
          align-items: center;
          margin-left: 20px;
          background-image: url("../../../assets/logoTxt1.png");
          background-repeat: no-repeat;
          //background-size: cover;
          background-position:0 center ;
        }

        @media (max-width: 1000px) {
          .logoBox {
            width: 35px;
            background-image: url("../../../assets/smallLogo0.5.png");
          }

          .logoTxt{
            width: calc(100% - 35px);
            margin-left: 10px;
            background-image: url("../../../assets/logoTxt0.5.png");
          }
        }
      }



      .rightMenu{
        width: calc(100% - 400px);
        height: 100%;
        display: flex;
        padding: 0 5%;


        .menuBox{
          width: 25%;

          color: #fff;

          font-weight: 900;
          cursor: pointer;

          .boxMain{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          }

          .topName{
            font-size: 19px;
          }
          .bottomEnglishName{
            font-size: 12px;
            text-align: center;
            white-space: nowrap;
          }
        }



        .activeMenu{
          background-image: url("../../../assets/activeMenu.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;

        }
      }
  }



  .indexMain{
    width: 100%;
    height: calc(100% - 80px);
    display: flex;
    background: #F5F5F5;
    border-radius: 10px;
    overflow: hidden;

    .indexSidebar{
       width: 21%;
      height: 100%;
      background: #fff;
      padding: 10px;

      .userInfo{
        width: 100%;
        height: 150px;

        .userMsg{
          width: 100%;
          height: 90px;
          display: flex;
          cursor: pointer;


          .leftImg{
            width: 60px;
            height: 100%;
            display: flex;
            justify-items: center;
            align-items: center;

            .imgBoxClass{
              width: 60px;
              height: 60px;
              border-radius: 50%;
              overflow: hidden;
              display: flex;
              justify-content: center;
            }
          }

          .rightInfo{
            width: calc(100% - 60px);
            height: 100%;
            font-size: 14px;
            padding-left: 10px;


            .userName{
              width: 100%;
              height: 30px;
              font-size: 18px;
              display: flex;
              align-items: center;
            }

            .zhicheng{
              width: 100%;
              height: 30px;
              display: flex;
              align-items: center;
              color: #FF7B00;
            }

            .dengluTime{
              width: 100%;
              height: 30px;
              color: #999999;
              display: flex;
              align-items: center;
            }
          }
        }

        .vipTips{
          width: 100%;
          height: 30px;

          ::v-deep .el-divider{
            background-color: #71CDC4!important;

          }
          .el-divider__text{
            white-space: nowrap;
          }

          ::v-deep .el-icon-mobile-phone{
            background-image: url("../../../assets/icon1.png");
            background-size: 17px;
            background-position: center;
            background-repeat: no-repeat;
          }

          ::v-deep .el-icon-mobile-phone:before {
            content: "11";
            visibility: hidden;
          }


          }
      }

      .paiming{
        width: 100%;
        height: 100px;
        padding: 0 5%;
        display: flex;


        .navList{
          width: 25%;
          height: 100%;

          .navIcon{
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .navNum{
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #01AF9E;
            font-weight: 520;
          }

          .navTxt{
            width: 100%;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            color: #333333;
          }
        }
      }

      .kechengBox{
        width: 100%;
        height: calc(100% - 250px);
        padding-top: 10px;

        .myKecheng{
          width: 100%;
          height: 50%;
          padding-left: 10px;
        }

        .YesKecheng{
          width: 100%;
          height: 50%;
          padding-left: 10px;
        }

        .titleBox{
          width: 100%;
          height: 50px;
          display: flex;
          align-items: center;

          .leftIcon{
            width: 40px;
            height: 40px;

          }

          .rightTxtx{
            width: calc(100% - 50px);
            height: 100%;
            padding-top: 5px;
            padding-left: 10px;

            .zhuTitle{
              width: 100%;
              height: 20px;
              display: flex;
              font-size: 14px;
              font-weight: 500;
              align-items: center;
            }

            .ciTitle{
              width: 100%;
              height: 18px;
              display: flex;
              font-size: 12px;
              font-weight: normal;
              letter-spacing: 0em;
              color: #999999;
              align-items: center;

            }
          }
        }

        .titleList{
          width: 100%;
          height: calc(100% - 50px);
          overflow-y: auto;

          .listOne{
            width: 100%;
            height: 30px;
            display: flex;
            align-items: center;
            margin-top: 5px;
            cursor: pointer;

            .leftIcon{
              width: 18px;
              height: 18px;
            }

            .rightTxtx{
              width: calc(100% - 35px);
              height: 100%;
              padding-left: 10px;
              font-size: 12px;
              font-weight: normal;
              line-height: 14px;
              letter-spacing: 0em;
              color: #999999;
              display: flex;
              align-items: center;
            }
          }

        }
      }
    }

    .indexPageContent{
      width: calc(100% - 21%);
      height: 100%;
      padding: 40px;

    }
  }


  @media (max-width: 1000px) {
    .indexHeader {
      height: 60px;

      .leftLogoTitle{
        width: 220px;
      }

      .rightMenu{
        width: calc(100% - 220px);
        padding: 0;
      }
    }

    .indexMain{
      height: calc(100% - 60px)!important;
    }



  }


}



</style>
